import {isNil} from 'ramda';

import type {SubscribeToNotificationsApiArg} from '../types';
import {MAX_CACHE_SIZE} from './subscriptionConstants';

/**
 * Appends a notification to the cache, evicting the oldest once the ring
 * buffer is full so the cache is bounded.
 */
export const appendNotification = (
  draft: SubscribeToNotificationsApiArg[] | undefined,
  notification: SubscribeToNotificationsApiArg
): SubscribeToNotificationsApiArg[] => {
  if (isNil(draft)) {
    return [notification];
  }

  if (draft.length >= MAX_CACHE_SIZE) {
    return [...draft.slice(1), notification];
  }

  return [...draft, notification];
};
